import { SvgIcon } from '@mui/material'

const SvgHelp = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgHelp" {...props}>
    <path
      d="M32 0C14.331 0 0 14.331 0 32a31.764 31.764 0 003.888 15.288L0 64l16.712-3.888A31.764 31.764 0 0032 64c17.669 0 32-14.331 32-32S49.669 0 32 0z"
      fill="#fff"
    />
    <path
      d="M33.69 39.247h-5.964v-3.216c0-1.405.163-2.463.509-3.135.326-.692 1.059-1.588 2.198-2.707l3.847-3.847c.814-.875 1.221-1.975 1.221-3.277 0-1.303-.427-2.382-1.262-3.237-.855-.855-1.934-1.303-3.277-1.303s-2.443.407-3.359 1.242c-.896.835-1.425 1.934-1.567 3.298h-6.392c.346-3.135 1.567-5.578 3.664-7.349 2.097-1.771 4.702-2.667 7.837-2.667s5.679.855 7.654 2.565c1.975 1.71 2.952 4.092 2.952 7.145 0 2.117-.57 3.868-1.73 5.272-.672.835-1.181 1.445-1.527 1.791-.346.346-.814.794-1.405 1.344-.59.55-1.079 1.018-1.486 1.425s-.733.753-.977 1.038c-.631.774-.957 1.873-.957 3.277v2.341h.021zm-2.871 11.725c-1.099 0-2.056-.387-2.87-1.14-.814-.753-1.221-1.669-1.221-2.748 0-1.079.387-1.995 1.181-2.768a3.95 3.95 0 012.85-1.16c1.099 0 2.056.387 2.87 1.14.814.753 1.201 1.669 1.201 2.748 0 1.079-.387 1.995-1.181 2.768-.774.773-1.73 1.16-2.83 1.16z"
      fill="#64b5f6"
    />
  </SvgIcon>
)

export default SvgHelp
